// Los archivos se nombran como {timestampMs}-{ddmmyyyy}_{categoria}_{id}.pdf.
// El prefijo numerico (timestamp) no le aporta nada al usuario; se oculta
// solo visualmente, el dato completo sigue intacto en BD/exportables.
export const acortarNombreArchivo = (nombreArchivo) => {
  if (!nombreArchivo) return nombreArchivo;
  return nombreArchivo.replace(/^\d+-/, "");
};

export const formatMoneda = (valor) =>
  valor === null || valor === undefined
    ? "-"
    : Number(valor).toLocaleString("es-CO", { style: "currency", currency: "COP" });
